import React from 'react'

const { formatText, FormattedText } = require('core/i18n').i18n;

const mainTranslationKey = 'profileUpdateDocumentation'
export const translateText = (value, params) => formatText(`${mainTranslationKey}-${value}`, params)
export const translateTextHtml = value => <FormattedText value={`${mainTranslationKey}-${value}`} />